import { UpdateAccountInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateAccountMutationAtom = createMutationAtomFactory(
  'crm.accountUpdate',
  ({ id, ...account }: UpdateAccountInput & { id: string }) => ({
    crmAccountUpdate: {
      __args: {
        id,
        input: account,
      },
      id: true,
    },
  }),
);
